<p-dialog
  header="Finalizar Pagamento"
  [(visible)]="display"
  [modal]="true"
  [style]="{ width: '80vw', height: '80vh' }"
>
  <div class="payment-modal">
    <div class="payment-summary-container">
      <div class="payment-summary">
        <p class="total">
          Total: {{ venda.total | currency : "BRL" : "symbol" }}
        </p>
        <p class="discont">
          <label for="discount">Desconto</label>
          <p-inputNumber
            [(ngModel)]="venda.desconto"
            mode="currency"
            currency="BRL"
            name="discount"
            locale="pt-BR"
          ></p-inputNumber>
        </p>
      </div>
      <div class="input-field">
        <label for="cliente"> Cliente </label>

        <p-autoComplete
          [(ngModel)]="selectedCustomer"
          [suggestions]="optionsCustomers"
          (completeMethod)="searchCustomer($event)"
          field="label"
          placeholder="Selecione o Cliente"
        ></p-autoComplete>
      </div>
    </div>

    
    <div class="flex flex-col w-[30%]">
      <label for="observacao" class="mb-1 font-medium text-gray-700">Observação</label>
      <textarea
        id="observacao"
        placeholder="Digite sua observação"
        [(ngModel)]="venda.observacao"
        name="observacao"
        rows="4"
        class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
      ></textarea>
    </div>
    
    

    <!-- Método de Pagamento -->
    <div class="input-field payment-method">
      <label>Método de Pagamento:</label>
      <p-dropdown
        [(ngModel)]="venda.pagamento"
        [options]="paymentMethods"
        placeholder="Escolha o Método"
        [filter]="true"
        filterBy="name"
        (onChange)="onPaymentMethodChange()"
      ></p-dropdown>
    </div>

    <div *ngIf="venda.pagamento == metodoPagamentoEnum.dinheiro">
      <label>Valor Recebido:</label>
      <p-inputNumber
        [(ngModel)]="receivedAmount"
        mode="currency"
        currency="BRL"
        locale="pt-BR"
        (onChange)="calculateChange()"
      ></p-inputNumber>
      <p>Troco: {{ change | currency : "BRL" : "symbol" }}</p>
    </div>

    <div class="payment-actions">
      <button
        pButton
        label="Confirmar Pagamento"
        (click)="confirmPayment()"
      ></button>
      <button pButton label="Cancelar" (click)="cancelPayment()"></button>
    </div>
  </div>
</p-dialog>
